import React, { useState } from "react";
import Header from "../../layout/Header";
import SampleFile from "../../../sample/customers/CustomerRegistrationHist.csv";
import { downloadIcon, uploadCSVIcon, rocketLaunch, summaryFileIcon } from "../../../Image/Index";
import { Link } from "react-router-dom";
import { customerValidateUserJourneyCSV, histCustomerBulkUpload } from "../../../actions/auth";

const ImportCustomers = () => {
    const [nextTab, setNextTab] = useState(0);
    const [file, setFile] = useState(null);
    const [message, setMessage] = useState("");
    const [state, setState] = useState({
        totalCustomer: "",
        progressComplete: false,
        progressLoading: false,
    });

    const { totalCustomer, progressComplete, progressLoading } = state;
    const onchangeFile = async (event) => {
        // setFile(event.target.files[0]);
        const maxFileSize = 26214400; // 25mb
        if (event.target.files[0].type === "text/csv") {
            if (event.target.files[0].size > maxFileSize) {
                setMessage("exceed maximum file size");
            } else {
                let response = await customerValidateUserJourneyCSV(event.target.files[0]);
                const { message, totalCount } = response;
                setMessage(message);
                if (message === "valid csv") {
                    setFile(event.target.files[0]);
                    setState({ ...state, totalCustomer: totalCount });
                }
            }
        } else {
            setMessage("File isn't in csv format");
        }
    };

    const uploadFile = async () => {
        const token = JSON.parse(localStorage.getItem("token_gen"));
        setNextTab(2);
        setState({ ...state, progressLoading: true });
        const res = await histCustomerBulkUpload(file, token?.access_token);
        setState({ ...state, progressComplete: true, progressLoading: false });
        if (res.message === "success") {
            setMessage(res.message);
        } else {
            setMessage(res.message);
        }
    };

    return (
        <>
            <Header name={"Import Customers"} />
            <div className="dashboard__content">
                <div className="dashboard__importCustomers">
                    <div className="dashboard__importHeading">
                        <Link to="/customers-list">
                            <i className="fa-solid fa-arrow-left"></i> Back
                        </Link>
                        <h6>Import Customers</h6>
                        <p>
                            Import your customers in bulk.{" "}
                            <span title="This option will help you to upload customer to our portal.">
                                <i className="fa-solid fa-circle-info"></i>
                            </span>
                        </p>
                    </div>
                    <div className="dashboard__importMainBox">
                        {nextTab === 0 && (
                            <div className="dashboard__importBox dashboard__importBox--stepOne">
                                <div className="dashboard__importHeader">
                                    <ul>
                                        <li className="active">
                                            <span className="dashboard__importNumber">1</span>
                                            <span className="dashboard__importText">Prepare your file</span>
                                            <span className="dashboard__importArrow">
                                                <i className="fa-solid fa-chevron-right"></i>
                                            </span>
                                        </li>
                                        <li>
                                            <span className="dashboard__importNumber">2</span>
                                            <span className="dashboard__importText">Upload</span>
                                            <span className="dashboard__importArrow">
                                                <i className="fa-solid fa-chevron-right"></i>
                                            </span>
                                        </li>
                                        <li>
                                            <span className="dashboard__importNumber">3</span>
                                            <span className="dashboard__importText">Import Customers</span>
                                        </li>
                                    </ul>
                                </div>
                                <div className="dashboard__importBody">
                                    <p>
                                        <i className="fa-solid fa-check"></i>
                                        Download our sample
                                        <Link to={SampleFile} download="CustomerSampleFile" target="_blank">
                                            CSV file <img src={downloadIcon} alt="" />
                                        </Link>
                                    </p>
                                    <p>
                                        <i className="fa-solid fa-check"></i>Add customer according to the sample file header.If you have more the 100 customer import in baches.
                                    </p>
                                    <p>
                                        <i className="fa-solid fa-check"></i>Double check each data is next to the correct numbers of columns.
                                    </p>
                                </div>
                                <div className="dashboard__importFooter">
                                    <button className="btn btn-primary btn-lg" onClick={() => setNextTab(1)}>
                                        Next
                                    </button>
                                </div>
                            </div>
                        )}
                        {nextTab === 1 && (
                            <div className="dashboard__importBox dashboard__importBox--stepTwo">
                                <div className="dashboard__importHeader">
                                    <ul>
                                        <li>
                                            <span className="dashboard__importNumber">
                                                <i className="fa-solid fa-check"></i>
                                            </span>
                                            <span className="dashboard__importText">Prepare your file</span>
                                            <span className="dashboard__importArrow">
                                                <i className="fa-solid fa-chevron-right"></i>
                                            </span>
                                        </li>
                                        <li className="active">
                                            <span className="dashboard__importNumber">2</span>
                                            <span className="dashboard__importText">Upload</span>
                                            <span className="dashboard__importArrow">
                                                <i className="fa-solid fa-chevron-right"></i>
                                            </span>
                                        </li>
                                        <li>
                                            <span className="dashboard__importNumber">3</span>
                                            <span className="dashboard__importText">Import Customers</span>
                                        </li>
                                    </ul>
                                </div>
                                <div className="dashboard__importBody">
                                    <form className="dashboard__importForm" encType="multipart/form-data">
                                        <div className="dashboard__importFormImage">
                                            <img src={uploadCSVIcon} alt="" />
                                        </div>
                                        {message ? (
                                            <div className="dashboard__importFormDescription">
                                                <div className="dashboard__importFormTitle" style={{ flexDirection: "column" }}>
                                                    <span className="dashboard__importFormLeft">{message === "valid csv" ? <span>File selected</span> : <span>We can't use this file.</span>}</span>{" "}
                                                    <span className="dashboard__importFormRight" style={{ margin: "0" }}>
                                                        <span className="dashboard__importFormText">
                                                            {message === "valid csv" && (
                                                                <button type="button" className="btn btn-sm btn-light" onClick={() => setMessage("")}>
                                                                    {file.name} X
                                                                </button>
                                                            )}
                                                            {message === "empty file" && <span>This file is empty</span>}
                                                            {message === "file length should be 100 rows" && <span>file length should be 100 rows</span>}
                                                            {(message === "invalid header uid" || message === "invalid header mobile") && <span>Some column headers are invalid & missing</span>}
                                                            {(message === "invalid uid" || message === "invalid mobile number") && <span>Some columns data are missing</span>}
                                                            {message === "File isn't in csv format" && <span>File isn't in csv format</span>}
                                                            {message === "exceed maximum file size" && <span>File size exceeds the limit of 25 MB</span>}
                                                        </span>
                                                    </span>
                                                </div>
                                                {message === "valid csv" ? null : (
                                                    <div className="dashboard__importFormSubtitle">
                                                        <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => setMessage("")}>
                                                            <i className="fas fa-redo"></i> Try again
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        ) : (
                                            <div className="dashboard__importFormDescription">
                                                <div className="dashboard__importFormTitle">
                                                    <span className="dashboard__importFormLeft">Drop your CSV file here or</span>
                                                    <span className="dashboard__importFormRight">
                                                        <span className="dashboard__importFormText">select a file from your computer</span>
                                                        <input className="dashboard__importFormTInput" type="file" accept={".csv"} onChange={onchangeFile} />
                                                    </span>
                                                </div>
                                                <div className="dashboard__importFormSubtitle">Maximum file size is 25 MB</div>
                                            </div>
                                        )}
                                    </form>
                                </div>
                                <div className="dashboard__importFooter">
                                    <button className="btn btn-outline-primary" onClick={() => setNextTab(0)}>
                                        Back
                                    </button>
                                    <button className="btn btn-primary" disabled={message === "valid csv" ? false : true} onClick={uploadFile}>
                                        Upload File
                                    </button>
                                </div>
                            </div>
                        )}

                        {nextTab === 2 && (
                            <div className="dashboard__importBox dashboard__importBox--stepThree">
                                <div className="dashboard__importHeader">
                                    <ul>
                                        <li>
                                            <span className="dashboard__importNumber">
                                                <i className="fa-solid fa-check"></i>
                                            </span>
                                            <span className="dashboard__importText">Prepare your file</span>
                                            <span className="dashboard__importArrow">
                                                <i className="fa-solid fa-chevron-right"></i>
                                            </span>
                                        </li>
                                        <li className="active">
                                            <span className="dashboard__importNumber">2</span>
                                            <span className="dashboard__importText">Upload</span>
                                            <span className="dashboard__importArrow">
                                                <i className="fa-solid fa-chevron-right"></i>
                                            </span>
                                        </li>
                                        <li>
                                            <span className="dashboard__importNumber">3</span>
                                            <span className="dashboard__importText">Import Customers</span>
                                        </li>
                                    </ul>
                                </div>
                                <div className="dashboard__importBody">
                                    <form className="dashboard__importForm">
                                        <div className="dashboard__importFormImage">
                                            <img src={uploadCSVIcon} alt="" />
                                        </div>
                                        <div className="dashboard__importFormDescription">
                                            <div className="dashboard__importFormTitle" style={{ flexDirection: "column" }}>
                                                <span className="dashboard__importFormLeft" style={{ margin: "0 0 10px" }}>
                                                    FILE NAME
                                                </span>
                                                <span className="dashboard__importFormRight" style={{ margin: "0" }}>
                                                    {progressLoading && (
                                                        <div className="dashboard__importProgressBarBox">
                                                            <div className="dashboard__importProgressBar">
                                                                <span className="dashboard__importProgressBarFill" style={{ width: "100%" }}></span>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {progressComplete && setNextTab(3)}
                                                </span>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="dashboard__importFooter"></div>
                            </div>
                        )}

                        {nextTab === 3 && (
                            <div className="dashboard__importBox dashboard__importBox--stepFour">
                                <div className="dashboard__importHeader">
                                    <ul>
                                        <li>
                                            <span className="dashboard__importNumber">
                                                <i className="fa-solid fa-check"></i>
                                            </span>
                                            <span className="dashboard__importText">Prepare your file</span>
                                            <span className="dashboard__importArrow">
                                                <i className="fa-solid fa-chevron-right"></i>
                                            </span>
                                        </li>
                                        <li>
                                            <span className="dashboard__importNumber">
                                                <i className="fa-solid fa-check"></i>
                                            </span>
                                            <span className="dashboard__importText">Upload</span>
                                            <span className="dashboard__importArrow">
                                                <i className="fa-solid fa-chevron-right"></i>
                                            </span>
                                        </li>
                                        <li className="active">
                                            <span className="dashboard__importNumber">3</span>
                                            <span className="dashboard__importText">Import Customers</span>
                                        </li>
                                    </ul>
                                </div>
                                <div className="dashboard__importBody">
                                    <div className="dashboard__importForm dashboard__importForm--column">
                                        <div className="dashboard__importFormImage">
                                            <img src={rocketLaunch} alt="" />
                                        </div>
                                        <div className="dashboard__importFormDescription">
                                            <div className="dashboard__importFormTitle">
                                                <span className="dashboard__importFormLeft">{message === "success" ? "Import successfully" : message}</span>
                                                <span className="dashboard__importFormRight">
                                                    <span className="dashboard__importFormText">
                                                        {message === "success" ? (
                                                            <>
                                                                Your customer data is successfully imported in the system. Click on this link <Link to="/customers-list">Customer List</Link> to view the list of your customers.
                                                            </>
                                                        ) : (
                                                            `There is a problem on the server side. Please try Some time later.`
                                                        )}
                                                    </span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="dashboard__importSidebar">
                        {!progressComplete ? (
                            <>
                                <div className="dashboard__importSidebarHeader">
                                    <p>following this example to formate your CSV file:</p>
                                </div>
                                <div className="dashboard__importSidebarBody">
                                    <div className="table-responsive">
                                        <table className="table table-striped table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>uid</th>
                                                    <th>mobile</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>CUS066390733</td>
                                                    <td>8860710047</td>
                                                </tr>
                                                <tr>
                                                    <td>CUS066390733</td>
                                                    <td>8860710047</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="dashboard__importSidebarBody">
                                    <div className="dashboard__importSidebarHeader">
                                        <p>File summary</p>
                                    </div>
                                    <div className="dashboard__importSidebarTop">
                                        <div className="dashboard__importSidebarIcon">
                                            <i className="fa-solid fa-user-check"></i>
                                        </div>
                                        <div className="dashboard__importSidebarContent">
                                            <span className="dashboard__importSidebarCount">{message === "success" ? totalCustomer : "0"}</span>
                                            <span className="dashboard__importSidebarText">Customers Found</span>
                                        </div>
                                    </div>
                                    <div className="dashboard__importSidebarBottom">
                                        <img src={summaryFileIcon} alt="" />
                                    </div>
                                </div>
                            </>
                        )}
                        <div className="dashboard__importSidebarFooter">
                            <p>
                                Need help?{" "}
                                <Link to="/help-details" state={{ fileGuideline: "Customers" }}>
                                    See our file guidelines <i className="fa-solid fa-arrow-up-right-from-square"></i>
                                </Link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ImportCustomers;
